import { RiArrowDropLeftLine, RiArrowDropRightLine } from 'react-icons/ri';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Row,
  TabPane,
} from 'reactstrap';
import { FaCarSide, FaRegIdCard } from 'react-icons/fa';
import './styles.css';
import { useState } from 'react';
import { toastError } from '@src/utility/Toast';
import apiOnboarding from '@src/services/api-onboarding';
import { useAuthOnboarding } from '@src/utility/hooks/useAuthOnboarding';
import { useLoadingGlobal } from '@src/utility/hooks/useLoadingGlobal';

interface WhichDocumentProps {
  handleChangeTabe: (tab: string) => void;
  handleGetIdOperator: (idOperator: string) => void;
  handleGetTypeForDocument: (typeDocument: string) => void;
  handleGetType: (type: string) => void;
}

const WhichDocument: React.FC<WhichDocumentProps> = ({
  handleChangeTabe,
  handleGetIdOperator,
  handleGetTypeForDocument,
  handleGetType,
}) => {
  const [type, setType] = useState('');
  const { verifyLogin } = useAuthOnboarding();
  const { showLoader, hideLoader } = useLoadingGlobal();

  const handleCheckOption = (type: string) => {
    setType(type);
  };

  const handleCreateOrGetOperator = async (data: any) => {
    try {
      showLoader();
      const res = await apiOnboarding.get(
        `api/operator/by-email/${data.email}?systemOrigin=${process.env.REACT_APP_SYSTEM_ORIGIN}`
      );

      handleGetIdOperator(res.data.data.id);
      handleGetType(res.data.data.typeDocument);
      handleGetTypeForDocument(type);

      await apiOnboarding.post(`api/operator/update-data-by-email`, {
        systemOrigin: process.env.REACT_APP_SYSTEM_ORIGIN,
        currentEmail: data.email,
        newEmail: data.email,
        name: data.name,
        typeCompany: data.company.class.toLowerCase(),
        toDocument: data.company.document,
        typeDocument: data.company.typeDocument,
        whitelabelId:
          data.company.class === 'WTL'
            ? null
            : data.company.companyId.toString(),
        phone: data.mobile,
        documentForValidation: type,
        typeRegister: 'TO_VALIDATE_COMPANY',
      });

      handleChangeTabe('4');
      hideLoader();
    } catch (error) {
      showLoader();
      const res = await apiOnboarding.post(`api/operator/create`, {
        systemOrigin: process.env.REACT_APP_SYSTEM_ORIGIN,
        name: data.name,
        email: data.email,
        typeCompany: data.company.class?.toLowerCase(),
        toDocument: data.company.document,
        typeDocument: data.company.typeDocument,
        whitelabelId:
          data.company.class === 'WTL'
            ? null
            : data.company.companyId.toString(),
        phone: data.mobile,
        documentForValidation: type,
        typeRegister: 'TO_VALIDATE_COMPANY',
      });
      handleGetIdOperator(res.data.data.id);
      handleGetType(res.data.data.typeDocument);
      handleGetTypeForDocument(type);
      handleChangeTabe('4');
      hideLoader();
    }
  };

  const handlePreparation = async () => {
    const userData = localStorage.getItem('userData');

    if (userData) {
      try {
        const data = JSON.parse(userData);
        await verifyLogin();
        await handleCreateOrGetOperator(data);
      } catch (error) {
        hideLoader();
        toastError({
          title: 'Houve um erro',
          description: 'Não foi possivel se preparar para verificação.',
        });
      }
    }
  };

  return (
    <TabPane tabId="3">
      <Row className="mb-2">
        <Col className="text-center">
          <h2 className="text-primary">Qual é seu documento?</h2>
          <p>Você precisa tê-lo em mãos para prosseguir com o validação.</p>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col sm="8">
          <Col sm="12">
            <Card
              color="light"
              style={{
                width: '100%',
              }}
              className={`cursor-card ${type === 'CNH' ? 'focus-active' : ''}`}
              onClick={() => handleCheckOption('CNH')}
            >
              <CardBody className="d-flex px-5">
                <div className="d-flex align-items-center mr-3">
                  <FaCarSide
                    size={25}
                    color={`${type === 'CNH' ? '#28c76f' : '#7367f0'}`}
                  />
                </div>
                <div>
                  <CardTitle className="text-dark">
                    <strong style={{ color: 'black' }}>CNH</strong>
                  </CardTitle>
                  <CardText style={{ color: 'black' }}>
                    Carteira Nacional de Habilitação
                  </CardText>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col sm="8">
          <Col sm="12">
            <Card
              color="light"
              style={{
                width: '100%',
              }}
              className={`cursor-card ${type === 'RG' ? 'focus-active' : ''}`}
              onClick={() => handleCheckOption('RG')}
            >
              <CardBody className="d-flex px-5">
                <div className="d-flex align-items-center mr-3">
                  <FaRegIdCard
                    size={25}
                    color={`${type === 'RG' ? '#28c76f' : '#7367f0'}`}
                  />
                </div>
                <div>
                  <CardTitle className="text-dark">
                    <strong style={{ color: 'black' }}>RG</strong>
                  </CardTitle>
                  <CardText style={{ color: 'black' }}>
                    Documento de Identidade
                  </CardText>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-between">
          <Button
            size="sm"
            onClick={() => handleChangeTabe('2')}
            color="secondary"
          >
            <RiArrowDropLeftLine size={25} /> Anterior
          </Button>
          <Button
            size="sm"
            onClick={() => handlePreparation()}
            color={`${type === '' ? 'secondary' : 'primary'}`}
            style={{ cursor: type === '' ? 'not-allowed' : 'pointer' }}
            disabled={type === ''}
          >
            Próximo <RiArrowDropRightLine size={25} />
          </Button>
        </Col>
      </Row>
    </TabPane>
  );
};

export default WhichDocument;
